<template>
    <div>
        <el-dialog :title="localRowData.system_name" :visible.sync="visible" width="80%" class="BorderRadius" :before-close="CloseDig" top="5vh">
            <div class="MaxHei">
                <div class="HeaderTop">
                    <div class="SearchHead">
                        <el-select  class="Wid120"size="medium" v-model="StateVal" @change="ReSetPage" clearable placeholder="状态">
                            <el-option label="已开启" :value="1"></el-option>
                            <el-option label="未开启" :value="0"></el-option>
                        </el-select>
                        <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                        </el-input>
                    </div>
                    <div class="BtnHead">
                        <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                        <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增项目</el-button>
                    </div>
                </div>
                <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" @selection-change="SeleChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="名称" min-width="200"></el-table-column>
                    <el-table-column prop="cot" label="申请限制数量" min-width="200">
                        <template slot-scope="scope">
                            <div>{{scope.row.cot?scope.row.cot:'不限制'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="icon" label="图标" min-width="100">
                        <template slot-scope="scope">
                            <i class="iconfont" :class="scope.row.icon"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="50">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ddd"
                            :active-value="1" :inactive-value="0" @change="ToggleSysType(scope.row)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="120" align="center">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" content="编辑" placement="top-start">
                                <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="删除" placement="top-start">                        
                                <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" layout="total,prev,pager,next,sizes" :total="Totol" hide-on-single-page></el-pagination>
            </div>
        </el-dialog>
        <el-dialog :title="Type=='Add'?'新增项目':'修改项目'" :visible.sync="NewData.blon" width="40%" class="BorderRadius">
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">项目名称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入项目名称" v-model="NewData.name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">申请限制数量：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入申请限制数量，默认为不限制" v-model="NewData.cot"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">图标：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入图标" v-model="NewData.icon"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">状态：</div>
                    <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminSysType",
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            rowData: {
                type: Object,
                default: {},
            },
        },
        data() {
            return{
                loading:false,
                SearchVal:"",
                StateVal:"",
                Page:1,
                PageSize:10,
                Totol:0,
                Data: [],
                SeleId:[],
                localRowData: {},
                Type:'Add',
                NewData:{
                    blon:false,
                    system_id:"",
                    id:"",
                    name:"",
                    icon:"",
                    cot:"",
                    status:0,
                }
            }
        },
        watch: {
            rowData: {
                immediate: true, 
                handler(newVal) {
                    this.localRowData = JSON.parse(JSON.stringify(newVal));
                    this.GetData()
                }
            }
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/system_sub/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    status:this.StateVal,
                    system_id:this.localRowData.id,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            SeleChange(val) {
                this.SeleId = val.map(item => item.id);
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.name = row.name;
                    this.NewData.icon = row.icon;
                    this.NewData.cot = row.cot;
                    this.NewData.status = row.status;
                }else{
                    this.Type='Add';
                }
                this.NewData.system_id = this.localRowData.id,
                this.NewData.blon = true;
            },
            Suc(){
                var url = this.Type=='Add'?'/admin/system_sub/save':'/admin/system_sub/update'
                this.$post(url,this.NewData).then(res=>{
                    if(res){
                        this.$message.success("操作成功");
                        this.ReSetPage();
                    }
                })
                this.$Tools.ResetData(this.NewData)
            },
            ToggleSysType(row){
                this.$post('/admin/system_sub/toggleStatus',{
                    ids:[row.id],
                    status:row.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            Delete(id){
                var Ids = id != "" ? [id] : this.SeleId;
                this.$confirm("此操作将永久删除项目, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/system_sub/delete', {
                        ids: Ids,
                    }).then(res => {
                        if (res) {
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            CloseDig() {
                this.$emit("cancel");
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        },
    };
</script>

<style scoped>
    .MaxHei {
        max-height: 650px;
        overflow-y: auto;
    }

    .PSTit {
        padding: 10px 0;
        font-size: 16px;
        font-weight: 700;
    }
    .DisFlex{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
</style>